import React, { useCallback } from 'react';
import './Timeline.css';

interface TimelineProps {
    duration: number;
    zoom?: number;
}

const Timeline: React.FC<TimelineProps> = ({ duration=0, zoom=1 }) => {
    const computeTime = useCallback(
        (secs: any) => {
          const minutes = Math.floor(secs / 60);
          const returnedMinutes = minutes < 10 ? `${minutes}` : `${minutes}`;
          const seconds = Math.floor(secs % 60);
          const returnedSeconds = seconds < 10 ? `0${seconds}` : `${seconds}`;
          return `${returnedMinutes}:${returnedSeconds}`;
        },
        []
      );

    return (
        <>
            <div>0:00</div>
            <div className='sep-tool-progress-inside-timeline'>
                <div>{computeTime(duration / 12)}</div>
                <div style={{ position: 'absolute', left: `${12.7 * zoom}vw` }}>{computeTime(duration / 6)}</div>
                <div style={{ position: 'absolute', left: `${19.2 * zoom}vw` }}>{computeTime(duration / 4)}</div>
                <div style={{ position: 'absolute', left: `${25.7 * zoom}vw` }}>{computeTime(duration / 3)}</div>
                <div style={{ position: 'absolute', left: `${32.2 * zoom}vw` }}>{computeTime(duration * 5 / 12)}</div>
                <div style={{ position: 'absolute', left: `${38.7 * zoom}vw` }}>{computeTime(duration / 2)}</div>
                <div style={{ position: 'absolute', left: `${45.2 * zoom}vw` }}>{computeTime(duration * 7 / 12)}</div>
                <div style={{ position: 'absolute', left: `${51.9 * zoom}vw` }}>{computeTime(duration * 8/ 12)}</div>
                <div style={{ position: 'absolute', left: `${58.4 * zoom}vw` }}>{computeTime(duration * 9 / 12)}</div>
                <div style={{ position: 'absolute', left: `${64.8 * zoom}vw` }}>{computeTime(duration * 10 / 12)}</div>
                <div style={{ position: 'absolute', left: `${71.3 * zoom}vw` }}>{computeTime(duration * 11 / 12)}</div>
            </div>
            <div>{computeTime(duration)}</div>
        </>
    );
};

export default Timeline;